// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialAuth_wrapper__A6aGU","google":"SocialAuth_google__d5-4M","facebook":"SocialAuth_facebook__qEGzC"};